export const BRAND_KEY = 'nutribullet'
export const BRAND_LABEL = 'Nutribullet'
export const BRAND_SHORT_LABEL = 'CB'
export const BRAND_CODE_MARKETING_CLOUD = 'ntb'
export const BRAND_INFO = {
    key: BRAND_KEY,
    label: BRAND_LABEL,
    short_label: BRAND_SHORT_LABEL,
}
export const BRAND_KEY_FILTER_CS = BRAND_KEY
export const MAIN_DOMAIN = 'nutribullet.com'
